import { Factory } from '../../services/Factory';

export class ExportInfoController {
  constructor($scope, $uibModalInstance, project, exportObj, exportService, exportDownloadService, accountService) {
    $scope.project = project;
    $scope.exportObj = exportObj;
    $scope.exportDownloadService = exportDownloadService;
    $scope.accountService = accountService;

    $scope.close = () => $uibModalInstance.close();
    $scope.replay = () => exportService.Replay($scope.exportObj);
  }
}

frontendApp.controller("ExportInfoController",  ["$scope", "$uibModalInstance", "project", "exportObj", "ExportService", "ExportDownloadService", "AccountService", Factory.Create(ExportInfoController)]);
